/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../app/common/errors/error.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../app/common/errors/error.service';
import * as import9 from 'primeng/components/growl/growl';
import * as import10 from 'primeng/components/dom/domhandler';
import * as import11 from '../../../../$$_gendir/node_modules/primeng/components/growl/growl.ngfactory';
import * as import12 from '@angular/core/src/linker/element_ref';
import * as import13 from '@angular/core/src/change_detection/differs/iterable_differs';
export class Wrapper_ErrorComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ErrorComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.ErrorComponent(p0);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_ErrorComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_ErrorComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.ErrorComponent>;
  _ErrorComponent_0_3:Wrapper_ErrorComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ErrorComponent_Host0,renderType_ErrorComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'oa-error',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ErrorComponent0(this.viewUtils,this,0,this._el_0);
    this._ErrorComponent_0_3 = new Wrapper_ErrorComponent(this.injectorGet(import8.ErrorService,this.parentIndex));
    this.compView_0.create(this._ErrorComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._ErrorComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ErrorComponent) && (0 === requestNodeIndex))) { return this._ErrorComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ErrorComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const ErrorComponentNgFactory:import7.ComponentFactory<import0.ErrorComponent> = new import7.ComponentFactory<import0.ErrorComponent>('oa-error',View_ErrorComponent_Host0,import0.ErrorComponent);
const styles_ErrorComponent:any[] = ([] as any[]);
var renderType_ErrorComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_ErrorComponent,{});
export class View_ErrorComponent0 extends import1.AppView<import0.ErrorComponent> {
  _text_0:any;
  _el_1:any;
  compView_1:import1.AppView<import9.Growl>;
  _DomHandler_1_3:import10.DomHandler;
  _Growl_1_4:import11.Wrapper_Growl;
  _text_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ErrorComponent0,renderType_ErrorComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'\n        ',(null as any));
    this._el_1 = import3.createRenderElement(this.renderer,parentRenderNode,'p-growl',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_1 = new import11.View_Growl0(this.viewUtils,this,1,this._el_1);
    this._DomHandler_1_3 = new import10.DomHandler();
    this._Growl_1_4 = new import11.Wrapper_Growl(new import12.ElementRef(this._el_1),this._DomHandler_1_3,this.parentView.injectorGet(import13.IterableDiffers,this.parentIndex));
    this.compView_1.create(this._Growl_1_4.context);
    this._text_2 = this.renderer.createText(parentRenderNode,'\n    ',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._text_0,
      this._el_1,
      this._text_2
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import10.DomHandler) && (1 === requestNodeIndex))) { return this._DomHandler_1_3; }
    if (((token === import9.Growl) && (1 === requestNodeIndex))) { return this._Growl_1_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1_0_0:any = this.context.msgs;
    this._Growl_1_4.check_value(currVal_1_0_0,throwOnChange,false);
    this._Growl_1_4.ngDoCheck(this,this._el_1,throwOnChange);
    this.compView_1.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._Growl_1_4.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_1.destroy();
    this._Growl_1_4.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./src/$$_gendir/app/common/errors/error.component.ngfactory.ts